/* Mastro - Service Worker Registration Helper (MS-PWA2-B)
 * Single responsibility: register /service-worker.js.
 * No UI, no update notifications, no auto reload, no auto unregister.
 */

export function register() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/service-worker.js").catch(() => {
        /* registration failure is non-fatal; Mastro stays online-first */
      });
    });
  }
}
